import React from "react";
import { useTranslation } from "react-i18next";

import { ToggleInput } from "@common/toggleInput";
import { Props } from "./types";
import styles from "./styles.scss";

function BlockedTasksToggle({ isToggled, toggle }: Props) {
  const { t } = useTranslation();

  return (
    <label className={styles.blockedTasksToggle} onClick={toggle}>
      <p className={styles.label}>
        {t("personalSynthesis.blockedTasksToggle")}
      </p>
      <ToggleInput isToggled={isToggled} />
    </label>
  );
}

export { BlockedTasksToggle };
